import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/BannerSection.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";

// Custom Arrow Components
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const BannerSection = () => {
  const [destination, setDestination] = useState("");
  const [isAutoSuggestVisible, setIsAutoSuggestVisible] = useState(false);
  const [trendingDestinations, setTrendingDestinations] = useState([]);
  const [filteredDestinations, setFilteredDestinations] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    arrival: "",
    nights: "",
    message: "",
  });

  const backgroundImages = [
    "/Images/tour/golden-triangle-01.jpg.jpeg",
    "/Images/tour/golden-triangle-02.jpg.jpeg",
    "/Images/tour/golden-triangle-03.jpg.jpeg",
    "/Images/tour/golden-triangle-04.jpg.jpeg",
  ];

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 4000,
    fade: true,
    arrows: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    pauseOnHover: false,
  };

  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const response = await fetch(
          "https://admin.climaxholidays.com/api/HolidayPackages/destinations"
        );
        const result = await response.json();
        if (result.success) {
          setTrendingDestinations(result.data);
        }
      } catch (error) {
        console.error("Error fetching destinations:", error);
      }
    };
    fetchDestinations();
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setDestination(value);
    if (value.trim() === "") {
      setFilteredDestinations([]);
      return;
    }
    const filtered = trendingDestinations.filter((dest) =>
      dest.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredDestinations(filtered);
    setIsAutoSuggestVisible(true);
  };

  const handleDestinationSelect = (dest) => {
    setDestination(dest.name);
    setIsAutoSuggestVisible(false);
    setFilteredDestinations([]);
    window.location.href = `/${dest.slug}`;
  };

  const handleSearchClick = () => {
    if (destination.trim() === "") return;
    const matched = trendingDestinations.find(
      (dest) => dest.name.toLowerCase() === destination.toLowerCase()
    );
    if (matched) {
      window.location.href = `/${matched.slug}`;
    } else {
      window.location.href = `/${destination.replace(/\s+/g, "-").toLowerCase()}`;
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email) {
      alert("Please fill in your name and email.");
      return;
    }

    try {
      const response = await axios.post(
        "https://eweblinktechnology.com/api/send-enquiry",
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      const data = response.data;

      if (data.success) {
        alert("Enquiry sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          checkIn: "",
          nights: "",
          message: "",
        });
      } else {
        alert("Failed to send enquiry. Please try again.");
      }
    } catch (error) {
      console.error("Error sending enquiry:", error);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <>
      <div className="holiday-banner-slider-wrapper">
      <Slider {...settings} className="background-slider">
        {backgroundImages.map((img, idx) => (
          <div key={idx}>
            <div className="holiday-banner">

              <div
                className="banner-image"
                style={{ backgroundImage: `url(${img})` }}
              ></div>

              <div className="banner-overlay blur-bg">
                <div className="banner-content modern">

                  {/* LEFT SIDE */}
                  <div className="left-side">
                    <h2>Why Book Budget Golden Triangle Tours With Us</h2>
                    <ul>
                      <li>✨ Expertly Designed Golden Triangle Itineraries</li>
                      <li>✨ Explore Delhi, Agra & Jaipur at the Best Budget Prices</li>
                      <li>✨ Comfortable Hotels & Private Transportation</li>
                      <li>✨ Professional Local Guides for Every Destination</li>
                      <li>✨ Flexible & Customizable Tour Packages</li>
                      <li>✨ Hassle-Free Sightseeing & Travel Planning</li>
                      <li>✨ Transparent Pricing – No Hidden Charges</li>
                      <li>✨ Ideal for Families, Couples & Solo Travelers</li>
                      <li>✨ Trusted by Thousands of Happy Travelers</li>
                      <li>✨ 24×7 Customer Support Throughout Your Journey</li>
                    </ul>
                  </div>

                  {/* RIGHT SIDE FORM */}
                  <div className="right-side">
                    <h3>Get a Free Quote</h3>
                    <form onSubmit={handleSubmit}>
                      <input type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange}/>
                      <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange}/>
                      <input type="text" name="phone" placeholder="Mob. No" value={formData.phone} onChange={handleChange}/>

                      <div className="date-row">
                        <input type="text" name="arrival" placeholder="Arrival" value={formData.arrival} onChange={handleChange}/>
                        <input type="text" name="nights" placeholder="Nights" value={formData.nights} onChange={handleChange}/>
                      </div>

                      <textarea name="message" placeholder="Message" value={formData.message} onChange={handleChange}></textarea>

                      <button type="submit">Submit →</button>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      </div>
    </>
  );
};

export default BannerSection;
